// extracted by mini-css-extract-plugin
export var headerCell = "_1o-1";
export var loadingSpinnerContainer = "_1o-4";
export var rowWrapper = "_1o-3";
export var standaloneTable = "_1o-5";
export var table = "_1o-0";
export var white = "_1o-2";